<template>
  <div class="btn-wrapper-black" :class="btnState">
    <a :href="cartUrl" target="_blank">{{ cta }}</a>
  </div>
</template>

<script>
  export default {
    name: 'ctacartbutton',

    props: {
      prodid: {
        required: true
      },
      active: {
        type: Boolean,
        required: true
      },
      cta: {
        type: String,
        required: true
      }
    },

    computed: {
      btnState() {
        return this.active == false ? "disabled" : "";
      },

      cartUrl() {
        return "https://www.pilates.com/?quantity=1&id=" + this.prodid;
      }
    }
  }
</script>

<style lang="scss" scoped>
.btn-wrapper-black {
  background-color: var(--black);
  border-radius: 3px;
  height: 56px;
  margin: 15px 0;
}

.btn-wrapper-black:hover a {
  color: #e7d49f;
}

a {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
  font-family: var(--roboto);
  font-size: 0.9375rem;
  font-weight: 700;
  line-height: 1.2;
  color: var(--white);
  text-decoration: none;
  text-transform: uppercase;
  padding: 10px;
  cursor: pointer;
}

.btn-wrapper-black.disabled {
  display: none;
}
</style>
